/**
 * Org ABDM HIP ID settings API.
 *
 * Per-org settings:
 *   - abdm_hip_id: the Health Information Provider ID this org is
 *     registered under with ABDM/NHA. Empty string (default) means unset.
 *   - abdm_registered_name: the facility name that HIP is registered under
 *     with ABDM. Used as the Facility name on every record we publish.
 *
 * Backend: GET / PUT /api/organisation/settings/hip
 * PUT is a partial update — an omitted field keeps its current value.
 */
import apiClient from './apiClient';

export const getHipSettings = async () => {
  const res = await apiClient.get('/api/organisation/settings/hip');
  return res.data;
};

/** Partial update: only the keys passed are sent. */
export const updateHipSettings = async ({ hipId, registeredName } = {}) => {
  const body = {};
  if (hipId !== undefined) body.abdm_hip_id = hipId;
  if (registeredName !== undefined) body.abdm_registered_name = registeredName;
  const res = await apiClient.put('/api/organisation/settings/hip', body);
  return res.data;
};

/** Re-run the ABDM check for the stored HIP ID. Same response shape as GET. */
export const verifyHipSettings = async () => {
  const res = await apiClient.post('/api/organisation/settings/hip/verify');
  return res.data;
};
